import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/unitsOfMeasure'
import Component from 'components/UnitsOfMeasure'

export default createListViewContainer({ actions, selectors: selectors.unitsOfMeasure })(Component)
